module.exports = __webpack_public_path__ + "static/media/1s.ccac1c59.png";